
export function loadDatePicker() {
    const pickerEl = document.querySelector('.date-picker');
    if (pickerEl)
        GlobalEnt.datePicker = new Picker(pickerEl, new Date());
}

export function Picker(pickerEl, date) {
    this.cancelFn = null;
    this.okFn = null;

    this.pickerEl = pickerEl;
    this.currentDate = date;
    this.calendarDate = new Date(this.currentDate);

    this.pickerContent = this.pickerEl.querySelector('.date-picker-content');
    this.selection = this.pickerEl.querySelector('.selection');
    this.calendar = this.pickerEl.querySelector('.calendar');
    this.nextAction = this.calendar.querySelector('.next-month');
    this.prevAction = this.calendar.querySelector('.prev-month');
    this.cancel = this.calendar.querySelector('.actions .cancel');
    this.ok = this.calendar.querySelector('.actions .ok');

    this.setSelectedDay = (date) => {
        this.currentDate = date;

        const zYear = this.selection.querySelector('.year');
        zYear.textContent = this.currentDate.getFullYear();

        const zDayOfWeek = this.selection.querySelector('.day-of-week');
        zDayOfWeek.textContent = toDayString(this.currentDate.getDay()) + ',';

        const zMonthDay = this.selection.querySelector('.month-day');
        zMonthDay.textContent = toMonthString(this.currentDate.getMonth()) + ' ' + this.currentDate.getDate();

        const zAllDays = this.calendar.querySelectorAll('.day');
        for (let i = 0; i < zAllDays.length; i++) {
            zAllDays[i].classList.remove('selected');
        }

        const zNewDay = this.calendar.querySelector('.day[data-date="' + this.currentDate.toDateString() + '"]');
        if (zNewDay)
            zNewDay.classList.add('selected');
    };


    this.setDate = (date) => {
        this.currentDate = date;
        this.calendarDate = new Date(this.currentDate);
        this.setSelectedDay(this.currentDate);
    };

    this.getDate = () => {
        return this.currentDate;
    };

    this.onCancel = (fn) => {
        this.cancelFn = fn;
    };

    this.onOk = (fn) => {
        this.okFn = fn;
    };

    this.show = (date) => {
        this.showCalendar(date);
    };

    this.hide = () => {
        this.hideCalendar();
    };

    this.nextClicked = () => {
        this.calendarDate.setMonth(this.calendarDate.getMonth() + 1);
        this.initMonth(this.calendarDate);
    };

    this.prevClicked = () => {
        this.calendarDate.setMonth(this.calendarDate.getMonth() - 1);
        this.initMonth(this.calendarDate);
    };

    this.dayClicked = (evt) => {
        this.currentDate = new Date(evt.target.dataset.date);
        this.calendarDate = new Date(this.currentDate);

        this.setSelectedDay(this.currentDate);
    };

    this.okClicked = () => {
        if (this.okFn) {
            this.okFn();
        }

        this.hideCalendar();
    };

    this.cancelClicked = () => {
        if (this.cancelFn) {
            this.cancelFn();
        }

        this.hideCalendar();
    };

    this.escClose = (evt) => {
        if (evt.key.toLowerCase() === 'escape' || evt.key.toLowerCase() === 'esc') {
            if (this.cancelFn) {
                this.cancelFn();
            }

            this.hideCalendar();
        }
    };

    this.preventClose = (evt) => {
        evt.stopPropagation();
    };

    this.showCalendar = (date) => {
        this.currentDate = date || this.currentDate;
        this.calendarDate = new Date(this.currentDate);

        this.pickerEl.style.display = 'block';

        this.initMonth(this.currentDate);
        this.setSelectedDay(this.currentDate);
        this.setLocation();

        this.nextAction.addEventListener('click', this.nextClicked);
        this.prevAction.addEventListener('click', this.prevClicked);
        this.cancel.addEventListener('click', this.cancelClicked);
        this.ok.addEventListener('click', this.okClicked);

        this.pickerEl.addEventListener('click', this.cancelClicked);
        this.pickerContent.addEventListener('click', this.preventClose);
        document.addEventListener('keyup', this.escClose);
    };

    this.hideCalendar = () => {
        this.nextAction.removeEventListener('click', this.nextClicked);
        this.prevAction.removeEventListener('click', this.prevClicked);
        this.cancel.removeEventListener('click', this.cancelClicked);
        this.ok.removeEventListener('click', this.okClicked);

        this.pickerEl.removeEventListener('click', this.cancelClicked);
        this.pickerContent.removeEventListener('click', this.preventClose);
        document.removeEventListener('keyup', this.escClose);

        this.pickerEl.style.display = 'none';
    };

    this.initMonth = (date) => {
        const daysDiv = this.calendar.querySelector('.days');
        const weeks = daysDiv.querySelectorAll('.week');
        for (let i = 0; i < weeks.length; i++) {
            const days = weeks[i].querySelectorAll('.day');
            for (let j = 0; j < days.length; j++) {
                days[j].removeEventListener('click', this.dayClicked);
            }
            daysDiv.removeChild(weeks[i]);
        }

        // Apply the date string to the UI.
        this.calendar.querySelector('.current-month').textContent = toFullMonthString(date.getMonth()) + ' ' + date.getFullYear();

        const dateIter = new Date(date.getFullYear(), date.getMonth(), 1);
        dateIter.setDate(dateIter.getDate() - dateIter.getDay());
        for (let i = 0; i < 6; i++) {
            const row = document.createElement('div');
            row.classList.add('week');

            for (let j = 0; j < 7; j++) {
                const day = document.createElement('div');

                day.setAttribute('data-date', dateIter.toDateString());
                if (dateIter.getMonth() === date.getMonth()) {
                    day.textContent = dateIter.getDate();
                    day.classList.add('day');
                    day.addEventListener('click', this.dayClicked);
                } else {
                    day.classList.add('day-placeholder');
                    day.textContent = '';
                }

                if (dateIter.toDateString() === new Date().toDateString()) {
                    day.classList.add('today');
                }

                row.appendChild(day);
                dateIter.setDate(dateIter.getDate() + 1);
            }
            daysDiv.appendChild(row);
        }

        this.setSelectedDay(this.currentDate);
    };

    this.setLocation = () => {
        const height = parseInt(this.pickerContent.offsetHeight);
        const width = parseInt(this.pickerContent.offsetWidth);
        this.pickerContent.style.top = 'calc(50% - ' + (height / 2) + 'px)';
        this.pickerContent.style.left = 'calc(50% - ' + (width / 2) + 'px)';
    }
}

function toDayString(dayOfWeek) {
    switch (dayOfWeek) {
        case 0:
            return 'Sun';
        case 1:
            return 'Mon';
        case 2:
            return 'Tue';
        case 3:
            return 'Wed';
        case 4:
            return 'Thu';
        case 5:
            return 'Fri';
        case 6:
            return 'Sat';
    }
}

function toMonthString(month) {
    switch (month) {
        case 0:
            return 'Jan';
        case 1:
            return 'Feb';
        case 2:
            return 'Mar';
        case 3:
            return 'Apr';
        case 4:
            return 'May';
        case 5:
            return 'Jun';
        case 6:
            return 'Jul';
        case 7:
            return 'Aug';
        case 8:
            return 'Sept';
        case 9:
            return 'Oct';
        case 10:
            return 'Nov';
        case 11:
            return 'Dec';
    }
}

function toFullMonthString(month) {
    switch (month) {
        case 0:
            return 'January';
        case 1:
            return 'February';
        case 2:
            return 'March';
        case 3:
            return 'April';
        case 4:
            return 'May';
        case 5:
            return 'June';
        case 6:
            return 'July';
        case 7:
            return 'August';
        case 8:
            return 'September';
        case 9:
            return 'October';
        case 10:
            return 'November';
        case 11:
            return 'December';
    }
}

export function hasDatePicker() {
    return document.querySelector('.date-picker');
}